const StyleD = () => {
  return (
    <div className="style-d">
      <style>{`
        .style-d {
          --bg-primary: #ffffff;
          --bg-secondary: #f5f5f5;
          --bg-accent: #000000;
          --text-primary: #000000;
          --text-secondary: #333333;
          --text-mono: #2d2d2d;
          --accent-red: #dc2626;
          --accent-blue: #1e40af;
          --accent-yellow: #ca8a04;
          --border-heavy: #000000;
          --border-light: #cccccc;
          --grid-lines: #e5e5e5;
        }
        
        .style-d.dark {
          --bg-primary: #0a0a0a;
          --bg-secondary: #1a1a1a;
          --bg-accent: #ffffff;
          --text-primary: #ffffff;
          --text-secondary: #cccccc;
          --text-mono: #d4d4d4;
          --accent-red: #ef4444;
          --accent-blue: #3b82f6;
          --accent-yellow: #eab308;
          --border-heavy: #ffffff;
          --border-light: #333333;
          --grid-lines: #262626;
        }

        .style-d {
          background: var(--bg-primary);
          color: var(--text-primary);
          font-family: 'Inter', sans-serif;
          line-height: 1.5;
          font-weight: 400;
        }
        
        .style-d h1, .style-d h2, .style-d h3 {
          font-family: 'Inter', sans-serif;
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: -0.02em;
          margin-bottom: 0.5rem;
        }
        
        .style-d h1 {
          font-size: 4rem;
          line-height: 0.9;
          border-bottom: 8px solid var(--border-heavy);
          padding-bottom: 1rem;
          margin-bottom: 2rem;
        }
        
        .style-d h2 {
          font-size: 2rem;
          line-height: 1;
          border-left: 6px solid var(--accent-red);
          padding-left: 1rem;
          margin-bottom: 1rem;
        }
        
        .style-d h3 {
          font-size: 1.2rem;
          color: var(--text-secondary);
          border-bottom: 2px solid var(--border-light);
          padding-bottom: 0.25rem;
          margin-bottom: 0.75rem;
        }
        
        .style-d .mono {
          font-family: 'JetBrains Mono', 'Consolas', monospace;
          color: var(--text-mono);
          font-weight: 500;
          background: var(--bg-secondary);
          padding: 0.125rem 0.375rem;
          font-size: 0.9em;
        }
        
        .style-d .brutalist-card {
          background: var(--bg-primary);
          border: 4px solid var(--border-heavy);
          padding: 2rem;
          margin-bottom: 2rem;
          position: relative;
        }
        
        .style-d .brutalist-card::before {
          content: '';
          position: absolute;
          top: -4px;
          right: -4px;
          width: 20px;
          height: 20px;
          background: var(--accent-red);
        }
        
        .style-d .grid-section {
          background-image: 
            linear-gradient(var(--grid-lines) 1px, transparent 1px),
            linear-gradient(90deg, var(--grid-lines) 1px, transparent 1px);
          background-size: 20px 20px;
          padding: 2rem;
          border: 2px solid var(--border-light);
        }
        
        .style-d .data-table {
          width: 100%;
          border-collapse: collapse;
          font-family: 'JetBrains Mono', monospace;
          font-size: 0.9rem;
          margin: 1rem 0;
        }
        
        .style-d .data-table th {
          background: var(--bg-accent);
          color: var(--bg-primary);
          padding: 0.75rem;
          text-align: left;
          font-weight: 700;
          border: 2px solid var(--border-heavy);
        }
        
        .style-d .data-table td {
          padding: 0.5rem 0.75rem;
          border: 1px solid var(--border-light);
          vertical-align: top;
        }
        
        .style-d .system-button {
          background: var(--bg-accent);
          color: var(--bg-primary);
          border: 4px solid var(--border-heavy);
          padding: 1rem 2rem;
          font-family: 'Inter', sans-serif;
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          cursor: pointer;
          transition: none;
          position: relative;
        }
        
        .style-d .system-button:hover {
          background: var(--bg-primary);
          color: var(--bg-accent);
        }
        
        .style-d .system-button:active {
          transform: translate(2px, 2px);
        }
        
        .style-d .catalog-number {
          font-family: 'JetBrains Mono', monospace;
          color: var(--accent-blue);
          font-weight: 700;
          font-size: 0.8rem;
          letter-spacing: 0.1em;
        }
        
        .style-d .functional-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 0;
          border: 4px solid var(--border-heavy);
        }
        
        .style-d .functional-grid > div {
          padding: 1.5rem;
          border-right: 2px solid var(--border-light);
          border-bottom: 2px solid var(--border-light);
        }
        
        .style-d .functional-grid > div:nth-child(odd) {
          background: var(--bg-secondary);
        }
        
        .style-d .highlight-bar {
          height: 4px;
          background: var(--accent-yellow);
          margin: 1rem 0;
        }
        
        .style-d .metadata {
          font-family: 'JetBrains Mono', monospace;
          font-size: 0.8rem;
          color: var(--text-secondary);
          margin-top: 0.5rem;
        }
      `}</style>
      
      <div className="max-w-7xl mx-auto px-8 py-12">
        <header style={{marginBottom: '4rem'}}>
          <div className="catalog-number">STYLE.04 — ARCHIVE BRUTALIST</div>
          <h1>FUNCTIONAL<br/>SYSTEMS</h1>
          <p style={{
            color: 'var(--text-secondary)', 
            fontSize: '1.1rem', 
            maxWidth: '600px',
            fontWeight: '500'
          }}>
            Raw, systematic design inspired by library catalogs, database interfaces, 
            and the <span className="mono">functional beauty</span> of information architecture.
          </p>
          <div className="highlight-bar"></div>
        </header>

        <section style={{marginBottom: '4rem'}}>
          <div className="brutalist-card">
            <h2>Information First</h2>
            <p style={{color: 'var(--text-secondary)', marginBottom: '1.5rem'}}>
              This approach prioritizes <span className="mono">data visibility</span>, systematic organization, 
              and uncompromising functionality. Every design decision serves the primary goal: 
              making complex information accessible and actionable.
            </p>
            
            <table className="data-table">
              <thead>
                <tr>
                  <th>ELEMENT</th>
                  <th>PURPOSE</th>
                  <th>IMPLEMENTATION</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Heavy Borders</td>
                  <td>Visual Structure</td>
                  <td>4px solid lines create clear boundaries</td>
                </tr>
                <tr>
                  <td>Monospace Type</td>
                  <td>Data Display</td>
                  <td>Fixed-width fonts for tabular information</td>
                </tr>
                <tr>
                  <td>Grid Systems</td>
                  <td>Organization</td>
                  <td>Visible grids make structure explicit</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section style={{marginBottom: '4rem'}}>
          <h2>System Components</h2>
          <div className="metadata">Last updated: 2025.09.11 | Components: 24 | Status: ACTIVE</div>
          
          <div className="functional-grid">
            <div>
              <h3>Catalog Interface</h3>
              <p style={{color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: '0.5rem'}}>
                Database-inspired layouts that make complex collections browsable and searchable.
              </p>
              <div className="catalog-number">CAT.001.A</div>
            </div>
            
            <div>
              <h3>Systematic Typography</h3>
              <p style={{color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: '0.5rem'}}>
                Bold, uppercase headers with monospace data create clear information hierarchy.
              </p>
              <div className="catalog-number">TYP.002.B</div>
            </div>
            
            <div>
              <h3>Grid Transparency</h3>
              <p style={{color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: '0.5rem'}}>
                Visible grid systems make the underlying structure apparent to users.
              </p>
              <div className="catalog-number">LAY.003.C</div>
            </div>
            
            <div>
              <h3>Functional Color</h3>
              <p style={{color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: '0.5rem'}}>
                Color serves meaning: red for alerts, blue for data, yellow for highlights.
              </p>
              <div className="catalog-number">COL.004.D</div>
            </div>
          </div>
        </section>

        <section className="grid-section" style={{marginBottom: '4rem'}}>
          <h2>Archive Philosophy</h2>
          <div style={{display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '2rem', alignItems: 'start'}}>
            <div>
              <p style={{color: 'var(--text-secondary)', marginBottom: '1rem'}}>
                Brutalist design in the archive context means <strong>radical honesty</strong> about function. 
                No decorative elements, no unnecessary ornament — just pure information architecture 
                made visible and beautiful through its systematic logic.
              </p>
              <p style={{color: 'var(--text-secondary)'}}>
                Perfect for institutions that want to emphasize their <span className="mono">technical expertise</span> 
                and systematic approach to knowledge organization.
              </p>
            </div>
            <div className="brutalist-card" style={{margin: 0}}>
              <h3>Core Values</h3>
              <ul style={{listStyle: 'none', padding: 0, margin: 0}}>
                <li style={{marginBottom: '0.5rem'}}>
                  <span className="mono">[01]</span> Function over form
                </li>
                <li style={{marginBottom: '0.5rem'}}>
                  <span className="mono">[02]</span> Systems thinking
                </li>
                <li style={{marginBottom: '0.5rem'}}>
                  <span className="mono">[03]</span> Radical clarity
                </li>
                <li>
                  <span className="mono">[04]</span> Honest materials
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section className="text-center" style={{padding: '3rem 0', border: '4px solid var(--border-heavy)'}}>
          <div className="catalog-number" style={{marginBottom: '1rem'}}>ACTION.REQUIRED</div>
          <h2 style={{marginBottom: '1rem'}}>SYSTEMATIC SOLUTIONS</h2>
          <p style={{
            color: 'var(--text-secondary)', 
            maxWidth: '500px', 
            margin: '0 auto 2rem',
            fontWeight: '500'
          }}>
            For institutions that value transparency, efficiency, and uncompromising functionality 
            in their digital systems.
          </p>
          <button className="system-button">
            ANALYZE SYSTEM
          </button>
        </section>
      </div>
    </div>
  );
};

export default StyleD;